<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1650px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.add') + this.$t('attributes.tourist_info') }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper
            :validator="$v.form"
            @submit.prevent="onSend"
            novalidate
          >
            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.title"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>
            <form-group
              horizontal
              name="picture"
              attribute="attributes.picture"
              :label="$t('attributes.picture')"
              grouped
            >
              <template #label>
                {{ $t('attributes.picture') }}
                <b-tooltip type="is-dark" label="640*400/限定jpg檔，100KB內">
                  <b-icon
                    size="is-small"
                    type="is-danger"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a
                  class="button is-primary"
                  :disabled="!selectedArea"
                  @click="onSelectPictureImage"
                >
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <p
                  v-if="form.picture"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px"
                >
                  <a
                    :href="CatalogBannerImage(form.picture)"
                    @click.prevent="
                      onClickImage(CatalogBannerImage(form.picture))
                    "
                  >
                    {{ form.picture }}
                  </a>
                </p>
              </b-field>
            </form-group>
            <form-group horizontal name="url" :label="$t('attributes.url')">
              <b-input
                v-model="form.url"
                name="url"
                :placeholder="$t('message.please_input') + $t('attributes.url')"
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="description"
              :label="$t('attributes.description')"
            >
              <template #label>
                {{ $t('attributes.description') }}
                <b-tooltip type="is-dark" label="150字內">
                  <b-icon
                    size="is-small"
                    type="is-danger"
                    icon="help-circle-outline"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-input
                v-model="form.desc"
                name="name"
                type="textarea"
                :placeholder="
                  $t('message.please_input') + $t('attributes.description')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="selected_catalog"
              :label="$t('attributes.selected_catalogs')"
            >
              <div class="catalog-select-wrap-all mt-0">
                <div
                  v-for="option in postCatalogs"
                  :key="option.catalog_no"
                  class="column is-3 is-marginless is-selectable catalog-select-tag"
                >
                  <b-tag
                    attached
                    closable
                    aria-close-label="Close tag"
                    size="is-medium"
                    @close="
                      onRemoveSelectedCatalogs(option, form.selected_catalogs)
                    "
                  >
                    {{ !option.status ? '[下架]' : '' }}
                    {{ option.name }}
                  </b-tag>
                </div>
              </div>
            </form-group>
            <form-group
              horizontal
              name="area_code"
              attribute="attributes.area"
              :label="$t('attributes.area')"
            >
              <b-select
                v-model="selectedArea"
                name="area_code"
                :loading="loadingAreas"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                expanded
                @input="onSelectArea"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.area') }}
                </option>
                <option
                  v-for="option in areas"
                  :key="option.code"
                  :value="option"
                >
                  {{ !option.status ? '[下架]' : '' }}
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>
            <form-group
              horizontal
              name="catalog"
              :label="$t('attributes.catalog')"
            >
              <div class="catalog-select-wrap">
                <div class="columns is-multiline is-mobile">
                  <b-checkbox
                    v-if="catalogsList.length > 0"
                    v-model="showOffCatalogs"
                    class="column is-4 is-marginless"
                    @input="onShowOffCatalogs"
                  >
                    {{ $t('attributes.show_off_items') }}
                  </b-checkbox>
                </div>
                <div class="columns is-multiline is-mobile">
                  <b-checkbox
                    v-for="option in catalogsList"
                    v-model="form.selected_catalogs"
                    :key="option.catalog_no"
                    :native-value="option"
                    :disabled="
                      form.selected_catalogs.findIndex(
                        c => c.catalog_no === option.catalog_no
                      ) !== -1
                    "
                    class="column is-4 is-marginless is-selectable"
                    @input="selected => onSelectedCatalog(option, selected)"
                  >
                    {{ !option.status ? '[下架]' : '' }}
                    {{ option.name }}
                  </b-checkbox>
                </div>
              </div>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button
            :loading="loading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="loading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.add') }}
          </b-button>
        </footer>
        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>
    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { OpenCatalogTouristInfoFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'
import { AREA_API } from '@/utils/apis'

export default {
  name: 'TouristInfoCreateForm',

  props: {
    areaCode: {
      type: String
    }
  },
  data() {
    return {
      loadingAreas: false,
      loading: false,
      areas: [],
      catalogs: [],
      catalogsList: [],
      selectedArea: null,
      selectedCatalog: null,

      sending: false,
      form: this.extractFormValues(),

      isImageModalActive: false,
      selectedImageUrl: null,
      postCatalogs: [],
      showOffCatalogs: false
    }
  },
  validations: {
    form: {
      area_code: { required },
      status: { required },
      title: { required, maxLength: maxLength(50) },
      desc: { required, maxLength: maxLength(200) },
      picture: { required, maxLength: maxLength(500) },
      url: { maxLength: maxLength(500) },
      selected_catalogs: { required }
    }
  },
  computed: {
    isLoading() {
      return this.loadingAreas || this.sending
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.selectedArea = null

        if (this.form.area_code) {
          this.selectedArea = this.areas.find(
            a => a.code === this.form.area_code
          )
          if (this.selectedArea) {
            this.catalogs = this.selectedArea.catalogs
            this.catalogsList = this.showOffCatalogs
              ? this.catalogs
              : this.catalogs.filter(c => c.status === true)
          } else {
            this.catalogs = []
            this.catalogsList = []
          }
        }
      } catch (e) {
        this.areas = []
        this.catalogs = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    onSelectArea(option) {
      this.selectedArea = option && option
      if (this.selectedArea) {
        this.catalogs = this.selectedArea.catalogs
        this.catalogsList = this.showOffCatalogs
          ? this.catalogs
          : this.catalogs.filter(c => c.status === true)
      } else {
        this.catalogs = []
        this.catalogsList = []
      }
    },
    extractFormValues() {
      return {
        area_code: this.areaCode,
        status: true,
        title: '',
        desc: '',
        picture: '',
        url: '',
        selected_catalogs: []
      }
    },
    onShowOffCatalogs(selected) {
      this.showOffCatalogs = !!selected
      this.catalogsList = this.showOffCatalogs
        ? this.catalogs
        : this.catalogs.filter(c => c.status === true)
    },
    onSelectedCatalog(catalog, selectedCatalogs) {
      let index = selectedCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      const selected = index !== -1

      index = this.postCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      if (index === -1) {
        this.postCatalogs = [...this.postCatalogs, catalog]
      }

      index = this.form.selected_catalogs.findIndex(
        z => z.catalog_no === catalog.catalog_no
      )
      if (selected) {
        if (index === -1) {
          this.form.selected_catalogs = [
            ...this.form.selected_catalogs,
            catalog
          ]
        }
      } else {
        if (index !== -1) {
          this.form.selected_catalogs.splice(index, 1)
        }
      }
    },
    onRemoveSelectedCatalogs(catalog, selectedCatalogs) {
      let index = selectedCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      selectedCatalogs.splice(index, 1)
      this.form.selected_catalogs = selectedCatalogs
      this.postCatalogs = selectedCatalogs
    },
    async onSelectPictureImage() {
      if (!this.selectedArea) {
        this.$buefy.dialog.alert({
          title: '警告',
          message: '<b>請選擇線別</b>!',
          confirmText: '確認'
        })
        return
      }
      try {
        this.form.picture = await OpenCatalogTouristInfoFinder(null)
      } catch (e) {
        notifyService.error(e)
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async onSend() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.$emit('onSend', this.form)
    }
  }
}
</script>
